import { BuildHttpData, QarepaFileValidations } from '@qarepa/common';

export class FilesValidations {
  public static fileSize(file: number, size?: number): boolean {
    return QarepaFileValidations.validateFileSize(file, size);
  }

  public static extension(fileName: string) {
    const extensions = ['jpg', 'png', 'jpeg', 'svg', 'webp'];

    const extension = fileName?.split('.')?.pop()?.toLowerCase() ?? '';
    return extensions.includes(extension);
  }

  public static buildImage(
    formData: FormData,
    name: string,
    file: File[]
  ): FormData {
    return BuildHttpData.buildMultipartWithImages(formData, name, file);
  }

  public static buildMultipartWithImage(
    dataMultipart: FormData,
    multipartName: string,
    file: File
  ): FormData {
    if (file) {
      dataMultipart.append(multipartName, file, file.name);
    }
    return dataMultipart;
  }
}
